import SplashView from './splash-view';
export default SplashView;
